module.exports = __webpack_public_path__ + "img/confetti_4e.caca868a.svg";